<template>
  <div class="details_form_item">
    <Form ref="editModel" :model="editModel" :label-width="100">
      <FormItem label="患者姓名">{{ editModel.patientName }}</FormItem>
      <FormItem label="性别">{{ editModel.patientSex }}</FormItem>
      <FormItem label="检查日期">{{ editModel.examDate }}</FormItem>
      <FormItem label="检查项目">{{ editModel.examItem}}</FormItem>
      <FormItem label="报告医生">{{ editModel.reportDr }}</FormItem>
      <FormItem label="报告日期">{{ editModel.reportDate }}</FormItem>
      <FormItem label="审核医生">{{ editModel.verifyDr }}</FormItem>
      <FormItem label="影像所见">{{ editModel.findings }}</FormItem>
      <FormItem label="诊断结果">{{ editModel.diagnosis}}</FormItem>
      
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      organParentName: "",
    };
  },
  computed: {
    convertSex() {
      switch (this.editModel.patientSex) {
        case "F":
          return "女";
        case "M":
          return "男";
        default:
          return "未知";
      }
    },
  },
  created: function () {
    this.editModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>